
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---
import { JobCard } from '@/models/JobCard.model';
import { Vehicle, WorkshopSummary } from '@/models/Vehicle.model';

// --- Third Party ---
import dayjs from 'dayjs';

@Component
export default class LicenseIndicator extends Vue {
  @Prop() readonly item!: Vehicle | WorkshopSummary;
  @Prop() readonly disposalDate: string | undefined;
  @Prop() readonly showLicenseDate: boolean | undefined;
  @Prop({default: false}) readonly hideWhenCofPassed: boolean | undefined;
  @Prop({default: false}) readonly checkJobCards: boolean | undefined;
  @Prop({default: true}) readonly showJobCardStartDate: boolean | undefined;

  licenseWarning: boolean = false;
  licenseTooltip: string = '';
  licenseDisplayStyle: string = '';
  openLicenseJobCard: JobCard = {
    id: 0,
    vehicle1Id: 0,
    vehicle1Code: '',
    vehicle1TypeId: 0,
    vehicle1Type: '',
    startDate: '',
    jobTypeId: 0,
    jobType: '',  
    originalEta: '',
    lineItemCount: 0,
    createdById: 0,
    createdBy: '',
  };

  cofPassed: boolean = false;
  cofWarning: boolean = false;
  cofTooltip: string = '';
  cofDisplayStyle: string = '';
  openCofJobCard: JobCard = {
    id: 0,
    vehicle1Id: 0,
    vehicle1Code: '',
    vehicle1TypeId: 0,
    vehicle1Type: '',
    startDate: '',
    jobTypeId: 0,
    jobType: '',  
    originalEta: '',
    lineItemCount: 0,
    createdById: 0,
    createdBy: '',
  };

  @Watch('item', {
    immediate: true,
    deep: true,
  })
  checkWarning() {
    this.licenseWarning = false;
    this.licenseTooltip = '';
    this.licenseDisplayStyle = '';

    this.cofPassed = false;
    this.cofWarning = false;
    this.cofTooltip = '';
    this.cofDisplayStyle = '';

    if (this.item && this.item.id > 0) {
      if (!this.disposalDate) {
        const licenseEndDate = dayjs(this.item.licenseEndDate);
        const roadworthyDate = dayjs(this.item.roadworthyDate);

        // check if the license is due? (today is less than 60d until license date) 
        if (dayjs().isAfter(licenseEndDate.subtract(60, 'days'))) {
          // if license date is in the past
          if (dayjs().isAfter(licenseEndDate)) {
            // then check if the roadworthy date is less than 60d until today
            if (roadworthyDate.isAfter(dayjs().subtract(60, 'days'))) {
              // because then it has passed and we can apply for our license

              this.cofPassed = true;
              this.cofWarning = this.hideWhenCofPassed ? false : true;
              this.cofTooltip = 'COF Passed';
              this.cofDisplayStyle = '';

              this.licenseWarning = this.hideWhenCofPassed ? false : true;
              this.licenseTooltip = 'License Overdue';
              this.licenseDisplayStyle = 'overdue';

            } else {
              // license & COF are overdue

              this.cofPassed = false;
              this.cofWarning = true;
              this.cofTooltip = 'COF Due';
              this.cofDisplayStyle = 'overdue';

              this.licenseWarning = this.hideWhenCofPassed ? false : true;
              this.licenseTooltip = 'License Overdue';
              this.licenseDisplayStyle = 'overdue';
            }
          } else {
            // check if the roadworthy date is less than 60d until license date
            if (roadworthyDate.isAfter(licenseEndDate.subtract(60, 'days'))) {
              // if yes, cof has passed > license is due

              this.cofPassed = true;
              this.cofWarning = this.hideWhenCofPassed ? false : true;
              this.cofTooltip = 'COF Passed';
              this.cofDisplayStyle = '';

              this.licenseWarning = this.hideWhenCofPassed ? false : true;
              this.licenseTooltip = 'License Due';
              this.licenseDisplayStyle = 'service-due';

            } else {
              // if no, cof is due
              this.cofPassed = false;
              this.cofWarning = true;
              this.cofTooltip = 'COF Due';
              this.cofDisplayStyle = 'service-due';

              this.licenseWarning = false;
              this.licenseTooltip = '';
              // but is License *also* due??
              this.licenseDisplayStyle = dayjs().isAfter(licenseEndDate.subtract(30, 'days')) ? 'service-due' : '';

            }
          }
        }

        if (this.checkJobCards) {
          // check if there is an open job card for this vehicle
          this.openCofJobCard = this.$store.getters['jobCards/openJobCards'].find((item: JobCard) => {
            if (item.vehicle1Id === this.item.id && item.jobType === 'COF Prep') {
              return true;
            }

            if (item.vehicle2Id && item.vehicle2Id === this.item.id && item.jobType === 'COF Prep') {
              return true;
            }
          });

          this.openLicenseJobCard = this.$store.getters['jobCards/openJobCards'].find((item: JobCard) => {
            if (item.vehicle1Id === this.item.id && item.jobType === 'Display License') {
              return true;
            }

            if (item.vehicle2Id && item.vehicle2Id === this.item.id && item.jobType === 'Display License') {
              return true;
            }
          });

          if (this.openCofJobCard) {
            this.cofTooltip = 'Job Card Open';
            this.cofDisplayStyle = 'primary--text';
          }

          if (this.openLicenseJobCard) {
            this.licenseTooltip = 'Job Card Open';
            this.licenseDisplayStyle = 'primary--text';
          }
        }
      }
      if (this.item.suspended) {
        this.cofPassed = false;
        this.cofDisplayStyle =  'suspended';
        this.licenseDisplayStyle =  'suspended';
      }
    }
  }

  getJobDate(startDate: string) {
    return dayjs(startDate).format('DD/MM').toUpperCase();
  }
}
